module.exports = __webpack_public_path__ + "img/OM.57b77a23.jpg";